/* Toycycle: priority+ overflow for the desktop Shop by Brands ribbon.
   Moves brand links that don't fit the row into the "More" dropdown. */
class RibbonOverflow extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.header-ribbon__list');
    this.more = this.querySelector('.header-ribbon__more');
    this.panelList = this.querySelector('.header-ribbon__more-list');
    this.allLink = this.querySelector('.header-ribbon__more-all');
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    if (!this.list || !this.more || !this.panelList || !this.details) return;
    this.items = Array.from(this.list.children);

    this.details.addEventListener('toggle', () => {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    });
    this.onDocumentKeyup = (event) => {
      if (event.key !== 'Escape' || !this.details.open) return;
      this.closeMore();
      if (this.contains(document.activeElement)) this.summary.focus();
    };
    this.onDocumentClick = (event) => {
      if (this.details.open && !this.contains(event.target)) this.closeMore();
    };
    // Close when keyboard focus leaves the dropdown. relatedTarget is null on a
    // mouse click in Safari (links don't take focus), so a click on a brand link
    // inside the panel must not close it before the navigation fires.
    this.details.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !this.more.contains(event.relatedTarget)) this.closeMore();
    });
    document.addEventListener('keyup', this.onDocumentKeyup);
    document.addEventListener('click', this.onDocumentClick);

    this.scheduleUpdate = this.scheduleUpdate.bind(this);
    this.update = this.update.bind(this);
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
    this.resizeObserver.observe(this);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.scheduleUpdate);
    this.update();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    document.removeEventListener('keyup', this.onDocumentKeyup);
    document.removeEventListener('click', this.onDocumentClick);
  }

  closeMore() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }

  scheduleUpdate() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(this.update);
  }

  update() {
    if (window.innerWidth < 990) return;

    this.items.forEach((item) => {
      item.hidden = false;
      this.list.appendChild(item);
    });

    const fullWidth = this.clientWidth;
    const totalWidth = this.items.reduce((width, item) => width + item.offsetWidth, 0);
    if (totalWidth <= fullWidth) {
      this.more.hidden = true;
      return;
    }

    this.more.hidden = false;
    const available = fullWidth - this.more.offsetWidth - 8;
    const allUrl = this.allLink ? this.allLink.getAttribute('href') : null;
    let used = 0;
    this.items.forEach((item) => {
      used += item.offsetWidth;
      if (used <= available) return;
      const link = item.querySelector('a');
      if (allUrl && link && link.getAttribute('href') === allUrl) {
        item.hidden = true; // the pinned Shop All Brands link already covers it
      } else {
        this.panelList.appendChild(item);
      }
    });
  }
}

if (!customElements.get('ribbon-overflow')) customElements.define('ribbon-overflow', RibbonOverflow);
